import React from 'react';

const Unauthorized = () => {
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      Unauthorized
    </div>
  );
};

export default Unauthorized;
